module.exports = __webpack_public_path__ + "img/bwb6.svg";